/**
 * Sprawy panelu „Wymaga uwagi”, nazwy jak w wyliczeniu backendu — rozjazd
 * nazwy nie zepsuje kompilacji po żadnej stronie, więc stałe muszą się
 * zgadzać co do znaku.
 */
export enum AttentionKey {
  OVERDUE_INSTALLMENTS = 'OVERDUE_INSTALLMENTS',
  BUDGET_OVERRUN = 'BUDGET_OVERRUN',
  UNALLOCATED_TRANSACTIONS = 'UNALLOCATED_TRANSACTIONS',
  OVERDUE_REFUNDS = 'OVERDUE_REFUNDS',
  CANCELLED_BOOKING_HOLDING_MONEY = 'CANCELLED_BOOKING_HOLDING_MONEY',
  OVERPAYMENT = 'OVERPAYMENT',
  OVERDUE_EXPENSES = 'OVERDUE_EXPENSES',
  MISSING_BANK_ACCOUNT_FOR_CURRENCY = 'MISSING_BANK_ACCOUNT_FOR_CURRENCY',
  TOUR_LIMIT_BELOW_OCCUPANCY = 'TOUR_LIMIT_BELOW_OCCUPANCY',
  OPTION_LIMIT_BELOW_OCCUPANCY = 'OPTION_LIMIT_BELOW_OCCUPANCY',
  MANDATORY_TRANSPORT_SOLD_OUT = 'MANDATORY_TRANSPORT_SOLD_OUT',
  REQUIRED_OPTION_SOLD_OUT = 'REQUIRED_OPTION_SOLD_OUT',
  UNSIGNED_REQUIRED_CONSENT = 'UNSIGNED_REQUIRED_CONSENT',
  PARTICIPANT_WITHOUT_REQUIRED_INSURANCE = 'PARTICIPANT_WITHOUT_REQUIRED_INSURANCE',
  MISSING_REQUIRED_FIELD = 'MISSING_REQUIRED_FIELD',
  WAITLIST_WITH_FREE_SEATS = 'WAITLIST_WITH_FREE_SEATS',
  PENDING_CLIENT_CHANGE = 'PENDING_CLIENT_CHANGE',
  STALE_DRAFT_CHANGE = 'STALE_DRAFT_CHANGE',
  CHANGE_REJECTED_BY_CLIENT = 'CHANGE_REJECTED_BY_CLIENT',
  MESSAGE_FAILED = 'MESSAGE_FAILED',
  RECIPIENT_EMAIL_BOUNCING = 'RECIPIENT_EMAIL_BOUNCING',
}
